if (!customElements.get('collection-description')) {
  customElements.define(
    'collection-description',
    class CollectionDescription extends HTMLElement {
      connectedCallback() {
        this.text = this.querySelector('.collection-description__text');
        this.caption = this.querySelector('.collection-description__detail-caption');

        this.onResize = () => this.syncHeights();
        window.addEventListener('resize', this.onResize);

        this.querySelectorAll('img').forEach((img) => {
          if (img.complete) return;
          img.addEventListener('load', this.onResize, { once: true });
        });

        this.syncHeights();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.onResize);
      }

      get isMobile() {
        return window.innerWidth < 750;
      }

      syncHeights() {
        if (!this.text || !this.caption) return;

        this.text.style.removeProperty('min-height');
        this.caption.style.removeProperty('min-height');

        if (!this.isMobile) return;

        const maxHeight = Math.max(this.text.offsetHeight, this.caption.offsetHeight);

        this.text.style.minHeight = `${maxHeight}px`;
        this.caption.style.minHeight = `${maxHeight}px`;
      }
    }
  );
}
